
const state = {
  actionsTray: [],
  actionsFab: []
}

const getters = {}

const mutations = {
  loadActionsTray (state, actionsTray) {
    state.actionsTray.push(actionsTray)
  },
  loadActionsFab (state, actionsFab) {
    state.actionsFab = actionsFab
  },
  clearActionsTray (state) {
    state.actionsTray = []
  },
  clearActionsFab (state) {
    state.actionsFab = []
  }
}

const actions = {
  loadActionsTray ({commit}, actionsTray) {
    commit('loadActionsTray', actionsTray)
  },
  loadActionsFab ({commit}, actionsFab) {
    commit('loadActionsFab', actionsFab)
  },
  clearActionsTray ({commit}) {
    commit('clearActionsTray')
  },
  clearActionsFab ({commit}) {
    commit('clearActionsFab')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/files/actionsTray.js